// removed by extract-text-webpack-plugin
module.exports = {"a":"a","tip":"tip","h3":"h3","h2":"h2","h1":"h1","wide":"wide","wideStretchable":"wideStretchable","narrow":"narrow","right":"right","left":"left","box":"box","unpadded":"unpadded","dropdown":"dropdown","widewrap":"widewrap"};


//////////////////
// WEBPACK FOOTER
// ./src/components/shared.css
// module id = 25
// module chunks = 0